import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "p-2 fixed right-0 mr-5 mt-5 hidden xl:flex flex-row items-center justify-center z-10" };
const _hoisted_2 = { class: "mx-3" };
const _hoisted_3 = {
    key: 0,
    class: "absolute h-full w-full top-0 left-0 bg-white z-10"
};
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-times text-lg" }, null, -1);
const _hoisted_5 = [
    _hoisted_4
];
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-bars text-lg" }, null, -1);
const _hoisted_7 = [
    _hoisted_6
];
const _hoisted_8 = { class: "h-screen w-screen flex flex-col items-center justify-center px-1" };
const _hoisted_9 = { class: "text-primary font-bold text-2xl py-2" };
const _hoisted_10 = {
    class: "hide-scrollbar flex flex-row flex-wrap justify-center overflow-y-auto",
    style: { "max-height": "75vh" }
};
const _hoisted_11 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_user_dropdown = _resolveComponent("user-dropdown");
    const _component_LanguageSelector = _resolveComponent("LanguageSelector");
    const _component_MobileMenu = _resolveComponent("MobileMenu");
    const _component_selection_card = _resolveComponent("selection-card");
    const _component_spinner_modal = _resolveComponent("spinner-modal");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
                _createVNode(_component_user_dropdown, {
                    "no-selection": _ctx.$route.name === 'Selection'
                }, null, 8, ["no-selection"])
            ]),
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_LanguageSelector)
            ])
        ]),
        (_ctx.showPopUp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_MobileMenu, {
                    onCloseMenu: _cache[0] || (_cache[0] = ($event) => (_ctx.showPopUp = false)),
                    onDoLogout: _ctx.doLogout,
                    onGoToSelection: _ctx.goToSelection
                }, null, 8, ["onDoLogout", "onGoToSelection"])
            ]))
            : _createCommentVNode("", true),
        (_ctx.showPopUp)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "absolute right-4 top-4 cursor-pointer z-10 xl:hidden",
                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.showPopUp = false))
            }, _hoisted_5))
            : _createCommentVNode("", true),
        (!_ctx.showPopUp)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "absolute right-4 top-4 cursor-pointer z-10 xl:hidden",
                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.showPopUp = true))
            }, _hoisted_7))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h2", _hoisted_9, _toDisplayString(!_ctx.showWorkSpaces ? _ctx.$t('selection.whereDoYouWantToGo') : _ctx.$t('selection.selectVault')), 1),
            _createElementVNode("section", _hoisted_10, [
                (_ctx.hasNoWorkspace)
                    ? (_openBlock(), _createElementBlock("h3", _hoisted_11, _toDisplayString(_ctx.$t('vault.userHasNoVaults')), 1))
                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.personalWorkspaces, (personalSpace) => {
                        return (_openBlock(), _createBlock(_component_selection_card, {
                            key: personalSpace.id,
                            text: personalSpace.name,
                            color: "primary",
                            background: `https://picsum.photos/seed/${personalSpace.id}/300/300`,
                            onClick: ($event) => (_ctx.openPersonalSpace(personalSpace))
                        }, null, 8, ["text", "background", "onClick"]));
                    }), 128))
            ])
        ]),
        (_ctx.statusLoginSpinner)
            ? (_openBlock(), _createBlock(_component_spinner_modal, { key: 3 }, {
                message: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('spinner.logout')), 1)
                ]),
                _: 1
            }))
            : _createCommentVNode("", true)
    ], 64));
}
